import {Maps} from "../../../reckon-api";
import {Marker, Popup} from "react-leaflet";
import {Icon} from "leaflet";
import {defender_color} from "../../../theme";
import React, {useMemo} from "react";
import {positionToMapBounds, UtilityAbilityWithAgent} from "../MapRender";
import {formatDuration} from "../../../utils";


export default function UtilityAbilityOnMap(props: {util: UtilityAbilityWithAgent, containerSize:number, map: Maps}){
    const {util, containerSize} = props;

    const landingPoint = util.landing_point;
    
    const position = useMemo(() => {
        if (!landingPoint) return null;
        const pos_normalized = positionToMapBounds({x: landingPoint.x, y: landingPoint.y}, props.map);
        return {
            x: pos_normalized.x * containerSize,
            y: pos_normalized.y * containerSize
        };
    }, [landingPoint, containerSize, props.map]);

    const color = defender_color.replace('#','');
    const timeInRound = util.cast_position?.time_in_round ?? 0;

    // Early return after hooks
    if (!position) return null;

    return <Marker
                position={[position.x, position.y]}
                icon={
                    new Icon({
                        iconSize: [30, 30],
                        iconAnchor: [15, 15],
                        iconUrl: `https://res.cloudinary.com/xenesis/image/upload/r_max,bo_2px_solid_rgb:${color},e_colorize:${color ? 100 : 0},co_rgb:${color},c_scale,h_${40},w_${40}/v1/valAssets/${util.agent.replace('/', '_')}_${util.slot}.png`
                    })
                }
                draggable={false}
            >
        <Popup>
            <span>{util.slot}-{formatDuration(timeInRound)}</span>
        </Popup>
    </Marker>
}